import { render, staticRenderFns } from "./DoubleFormCard.vue?vue&type=template&id=6e02d23d&scoped=true&"
import script from "./DoubleFormCard.vue?vue&type=script&lang=ts&"
export * from "./DoubleFormCard.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleFormCard.vue?vue&type=style&index=0&id=6e02d23d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e02d23d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
